export const REQUEST_DEPENDENTS = 'REQUEST_DEPENDENTS'
export const RECEIVE_DEPENDENTS = 'RECEIVE_DEPENDENTS'
export const REQUEST_DEPENDENT = 'REQUEST_DEPENDENT'
export const RECEIVE_DEPENDENT = 'RECEIVE_DEPENDENT'
export const REQUEST_SAVE_DEPENDENT = 'REQUEST_SAVE_DEPENDENT'
export const RECEIVE_SAVE_DEPENDENT = 'RECEIVE_SAVE_DEPENDENT'
export const RESET_DEPENDENT = 'RESET_DEPENDENT'
